import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { K2ArticleHistory } from './K2ArticleHistory';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { SimpleTable } from './K2Tables';
import { fmtCz, fmtKc } from './k2utils';
import { fmtQty } from './itemsUtils';

const COLUMNS = [
  { key: 'article_code', label: 'Kód', className: 'whitespace-nowrap' },
  { key: 'article_name', label: 'Zboží', className: 'font-medium' },
  { key: 'warehouse', label: 'Sklad' },
  { key: 'quantity', label: 'Množství', num: true, render: (r) => <span className={r.quantity < 0 ? 'text-[#16A34A]' : ''}>{fmtQty(r.quantity, r.unit)}</span> },
  { key: 'value', label: 'Hodnota', num: true, render: (r) => <span className={r.value < 0 ? 'text-[#16A34A]' : 'font-semibold'}>{fmtKc(r.value)}</span> },
];

const Box = ({ label, value, cls, testId }) => (
  <div className={`p-3 rounded-xl ${cls}`} data-testid={testId}>
    <div className="text-xs text-[#57534E]">{label}</div>
    <div className="font-bold">{value}</div>
  </div>
);

export const K2DocDetail = ({ doc, items, loading, onClose }) => {
  const [hist, setHist] = useState(null);
  const lines = doc ? items.filter((x) => x.doc_rid === doc.rid).sort((a, b) => Math.abs(b.value) - Math.abs(a.value)) : [];
  const written = lines.filter((x) => x.value >= 0).reduce((a, x) => a + x.value, 0);
  const surplus = lines.filter((x) => x.value < 0).reduce((a, x) => a - x.value, 0);
  return (
    <Dialog open={!!doc} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto" data-testid="k2-doc-detail">
        {doc && (
          <>
            <DialogHeader>
              <DialogTitle className="font-['Manrope'] text-[#052E16]" data-testid="k2-doc-detail-title">
                Výdejka {doc.doc} <span className="text-sm font-normal text-[#57534E]">· {fmtCz(doc.date)} · řada {doc.book} · sklad {doc.warehouse}</span>
              </DialogTitle>
            </DialogHeader>
            {(doc.description || doc.partner) && (
              <p className="text-sm text-[#57534E]" data-testid="k2-doc-detail-desc">{[doc.description, doc.partner].filter(Boolean).join(' · ')}</p>
            )}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-sm">
              <Box label="Položek" value={doc.item_count} cls="bg-[#F8FAF8] text-[#052E16]" testId="k2-doc-detail-count" />
              <Box label="Hodnota dokladu" value={fmtKc(doc.amount)} cls="bg-[#F8FAF8] text-[#052E16]" testId="k2-doc-detail-amount" />
              <Box label="Odepsáno" value={fmtKc(written)} cls="bg-[#FEF2F2] text-[#DC2626]" testId="k2-doc-detail-written" />
              <Box label="Přebytek" value={fmtKc(surplus)} cls="bg-[#F0FDF4] text-[#16A34A]" testId="k2-doc-detail-surplus" />
            </div>
            {loading && lines.length === 0 ? (
              <div className="py-10 flex items-center justify-center gap-2 text-sm text-[#57534E]" data-testid="k2-doc-detail-loading">
                <Loader2 className="w-5 h-5 animate-spin text-[#16A34A]" /> Načítám položky z K2…
              </div>
            ) : (
              <SimpleTable testId="k2-doc-lines" columns={COLUMNS} rows={lines} rowKey={(r) => r.rid}
                onRowClick={(r) => setHist({ code: r.article_code, name: r.article_name })} />
            )}
            <p className="text-xs text-[#94A3B8]">Kliknutím na položku zobrazíte kompletní historii odpisů daného zboží.</p>
            <K2ArticleHistory article={hist} onClose={() => setHist(null)} />
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
